import { render, staticRenderFns } from "./BbsNotice.vue?vue&type=template&id=46edbaed&scoped=true&"
import script from "./BbsNotice.vue?vue&type=script&lang=ts&"
export * from "./BbsNotice.vue?vue&type=script&lang=ts&"
import style0 from "./BbsNotice.vue?vue&type=style&index=0&id=46edbaed&lang=scss&scoped=true&"
import style1 from "./BbsNotice.vue?vue&type=style&index=1&id=46edbaed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46edbaed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VChip,VDivider})
